// validators/number-validator.js
import { isEmpty } from "../utils/validator-utils";
import { ValidatorInterface } from "../validator-interface";

export class NumberValidator extends ValidatorInterface {
    getZodSchema(baseSchema, options = {}) {
        const message = options.message || "Please enter a valid number";

        // Check if the base schema already handles number conversion (like the builder's default)
        // This validator might be redundant if data-zod-type="number" is used,
        // but can be useful for adding number constraints to other base types or refining.

        // Refine ensures the value, after potential transforms, is a valid finite number.
        return baseSchema.refine(
            val => {
                // Allow empty strings/null/undefined if the field is optional (handled by Zod's optional())
                // Check if the value is considered "empty" in the context of optional fields
                if (isEmpty(val)) {
                    return true; // Let optional() handle this
                }
                const parsed = Number(val);
                return typeof parsed === "number" && Number.isFinite(parsed);
            },
            { message }
        );
    }

    getErrorMessage(field, options = {}) {
        return options.message || "Please enter a valid number";
    }
}
